import React from "react";

export const ContactPicker = ({contacts, setContact}) => {
  return (
    <select className='form-select form-select-lg mb-3' name="contactSelect" id="contactSelect">
      <option value="0" selected="selected">None Selected</option>
      {contacts.map((value) => (
      <option value={value} key={value}>{value}</option>
      ))}
    </select>
  );
};
